import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import './Navigation.css';

function Navigation({ hideLogin }) {
  const { currentUser } = useAuth();

  return (
    <header className="nav-container">
      <div className="nav-content">
        <Link to="/" className="logo">WTF Fertility</Link>
        <div className="nav-links">
          {!hideLogin && (
            currentUser ? (
              <Link to="/product" className="nav-cta">My Account</Link>
            ) : (
              <Link to="/login" className="nav-cta">Login</Link>
            )
          )}
        </div>
      </div>
    </header>
  );
}

export default Navigation; 